import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class PointsResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/points' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
